import { useMutation } from "@tanstack/react-query"
import { generateQRCodeForTwoFa, verifyOTPForTwoFa } from "../api/two-fa"
import {
  getUserFromLocalStorage,
  setOtpVerification,
  updatedUserFromLocalStorage,
} from "../utils"

export const useGenerateQRCode = () =>
  useMutation({
    mutationFn: generateQRCodeForTwoFa,
  })

export const useVerifyOTP = () =>
  useMutation({
    mutationFn: verifyOTPForTwoFa,
    onSuccess: () => {
      const user = getUserFromLocalStorage()
      setOtpVerification(true)
      updatedUserFromLocalStorage({ ...user, twoFAEnabled: true })
    },
  })
